import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

export function PageContainer(props: PropsWithChildren<any>) {
  return (
    <Box
      id="content"
      component="section"
      aria-label="AMP Content"
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: { xs: "1rem 1rem 2rem", lg: "1rem 2rem 3rem" },
        mt: { xs: "4rem", lg: "unset" },
        width: "100vw",
        height: "100vh",
        maxWidth: "2400px",
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      {props.children}
    </Box>
  );
}
